import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export interface Pane {
    content: string;
    language: string;
    name: string;
    opened?: true;
}

interface UploadedFile {
    url: string;
    name: string;
}

type PutWebShareProblemParams = { panes: Pane[]; problemLinkId: number; };
type PutWebShareProjectParams = { panes: Pane[]; projectName: string };
type PutWebShareParams = PutWebShareProblemParams | PutWebShareProjectParams;

/**
 * Закидывает файлы-статику в бакет e7n-hosting
 */
export function putWebShare(params: PutWebShareParams): Promise<UploadedFile[]> {
    const { apiPutWebShare } = apiConfig.getStaticUrls();

    return postFetch(apiPutWebShare, params);
}
